import { Theme } from '@/src/ct-design/token/theme'
import { StepperSize } from './type'
import { TypographyVariant } from '../Typography/type'

// Stepper configuration based on size
export const stepperConfig = {
    // Small size (mobile)
    sm: {
        // Circle dimensions
        circle: {
            height: '28px',
            width: '28px'
        },
        // Typography
        typography: {
            circle: 'B2' as TypographyVariant,
            title: 'B3' as TypographyVariant
        },
        // Title styles
        title: {
            maxWidth: '52px',
            textAlign: 'center',
            marginLeft: '0',
            fontSize: '0.75rem'
        },
        // Title container
        titleContainer: {
            width: '50px',
            height: '32px'
        },
        // Layout
        layout: {
            contentDirection: 'column' as const,
            gap: (theme: Theme) => theme.spacing[1]
        },
        // Divider
        divider: {
            margin: (theme: Theme) => theme.spacing[2]
        }
    },
    // Medium size (desktop)
    md: {
        // Circle dimensions
        circle: {
            height: '32px',
            width: '32px'
        },
        // Typography
        typography: {
            circle: 'B1' as TypographyVariant,
            title: 'B2' as TypographyVariant
        },
        // Title styles
        title: {
            maxWidth: 'none',
            textAlign: 'left',
            marginLeft: (theme: Theme) => theme.spacing[1],
            fontSize: 'inherit'
        },
        // Title container
        titleContainer: {
            width: '',
            height: ''
        },
        // Layout
        layout: {
            contentDirection: 'row' as const,
            gap: '0'
        },
        // Divider
        divider: {
            margin: (theme: Theme) => theme.spacing[4]
        }
    }
}

// Helper function to get config for a size
export const getConfig = (size: StepperSize = 'md') => stepperConfig[size]
